module.exports = __webpack_public_path__ + "static/media/FullLogo_Clean.11bf0211.png";